"use client";

import type { HighlightedCode } from "codehike/code";
import { useEffect, useState } from "react";
import { highlight } from "codehike/code";

import { useLighterTheme } from "./_utils/lighter-theme";
import { CodeTransition } from "./code-transition";

export function CodeTransitionWithHighlighter({
  before,
  after,
  title,
  selectable,
  index,
  language,
}: {
  before: string;
  after: string;
  title: string;
  selectable?: boolean;
  index: number;
  language: string;
}) {
  const [highlightedBefore, setHighlightedBefore] =
    useState<HighlightedCode | null>(null);
  const [highlightedAfter, setHighlightedAfter] =
    useState<HighlightedCode | null>(null);
  const highlighterTheme = useLighterTheme();

  useEffect(() => {
    if (!before || !after) {
      return;
    }
    void (async () => {
      const highlightedBefore = await highlight(
        {
          lang: language,
          value: before,
          meta: "",
        },
        highlighterTheme,
      );
      const highlightedAfter = await highlight(
        {
          lang: language,
          value: after,
          meta: "",
        },
        highlighterTheme,
      );

      setHighlightedBefore(highlightedBefore);
      setHighlightedAfter(highlightedAfter);
    })();
  }, [before, after, highlighterTheme, language]);

  if (highlightedBefore === null || highlightedAfter === null) {
    return null;
  }

  return (
    <CodeTransition
      title={title}
      beforeCode={highlightedBefore}
      afterCode={highlightedAfter}
      selectable={selectable}
      index={index}
    />
  );
}
